module.exports = __webpack_public_path__ + "static/media/quality.3af53105.png";